import React from 'react';
import Typography from '../Typography';
import CustomButton from '../CustomButton';

const SelectInvestment = ({
    selectedPlan,
    setSelectedPlan,
    investmentAmount,
    setInvestmentAmount,
    totalReturn,
    setTotalReturn,
    error,
    setError,
}) => {
    const plans = [
        { name: 'Plan 1', term: 1, annualROI: 20, minInvestment: 50000 },
        { name: 'Plan 2', term: 2.5, annualROI: 25, minInvestment: 50000 },
        { name: 'Plan 3', term: 2.5, annualROI: 30, minInvestment: 50000 },
    ];

    const calculateROI = (amount, plan) => {
        if (!amount || !plan) return 0;
        const total = amount * (1 + (plan.annualROI / 100) * plan.term);
        return total.toFixed(2);
    };

    const handleInvestmentAmountChange = (e) => {
        const amount = e.target.value.replace(/[^0-9]/g, '');
        setInvestmentAmount(amount);
        if (selectedPlan) {
            setTotalReturn(calculateROI(amount, selectedPlan));
        }
        // if (amount < 50000) {
        //     setError('Minimum investment amount is $50,000');
        // } else {
        //     setError(null);
        // }
    };

    const handleSelectPlan = (plan) => {
        setSelectedPlan(plan);
        if (investmentAmount) {
            setTotalReturn(calculateROI(investmentAmount, plan));
        }
    };

    return (
        <div>
            <div className="grid sm:grid-cols-3 grid-cols-1 lg:gap-6 md:gap-3 gap-0">
                {plans.map((plan, index) => (
                    <div key={index} onClick={() => handleSelectPlan(plan)} className='select-investment-container cursor-pointer group border-[0.684px] pb-[24.62px] flex-shrink-0 border-[#212121] relative'>
                        <header className='grid grid-cols-4 relative  z-20'>
                            <div className={`select-investment-header max-h-[68px] group-hover:bg-[#DF0F11] col-span-3 flex items-center justify-center ${selectedPlan?.name === plan.name
                                ? 'bg-[#DF0F11]'
                                : 'bg-[#333333]'
                                }`}>
                                <Typography text={`${plan.term} YEAR${plan.term > 1 ? 'S_' : '_'}`} color={'#FFF'} transform={'uppercase'} size={'21.885px'} lineheight={'27px'} family={'Supply'} />
                            </div>
                            <div className={`col-span-1 select-investment-header-circle max-h-[68px] p-5 group-hover:bg-[#2D0303] flex items-center justify-center ${selectedPlan?.name === plan.name
                                ? 'bg-[#2D0303]'
                                : 'bg-[#FFFFFF]'
                                }`}>
                                <div className={`rounded-full group-hover:bg-[#DF0F11] group-hover:text-[#000000] ${selectedPlan?.name === plan.name
                                    ? 'bg-[#DF0F11] text-[#000000]'
                                    : 'bg-[#000000] text-[#FFFFFF]'
                                    } w-[40px] h-[40px] flex justify-center items-center p-[9.575px]`}>
                                    <Typography text={`0${index + 1}`} transform={'uppercase'} size={'21.885px'} lineheight={'10.943px'} family={'Supply'} />
                                </div>
                            </div>
                        </header>
                        <Typography className='select-investment absolute lg:block hidden right-0 h-full z-0' text={'%'} size={'400px'} weight={500} color={'#FFF'} family={'Supply'} lineheight={'158px'} transform={'uppercase'} />
                        <div className='flex pl-[24.62px] pr-[14.89px] mt-[34.88px] justify-center items-end'>
                            <Typography size={'32.828px'} className='lg:block md:hidden hidden' weight={500} lineheight={'41.034px'} color={'#FFF'} text={`${plan.annualROI}% ROI`} family={'Supply'} />
                            <Typography size={'31px'} className='lg:hidden md:block hidden' weight={500} lineheight={'38px'} color={'#FFF'} text={`${plan.annualROI}% ROI`} family={'Supply'} />
                            <Typography size={'42px'} className='lg:hidden md:hidden block' weight={500} lineheight={'38px'} color={'#FFF'} text={`${plan.annualROI}% ROI`} family={'Supply'} />
                            <Typography family={'Supply'} text={(<><span className='text-white'>/</span><span className='text-[#DF0F11] '>Annually</span></>)} />
                        </div>
                        <div className='mt-[21.885px] px-[24.62px]'>
                            <Typography className='lg:block md:hidden hidden' opacity={0.6} text={
                                plan.name === 'Plan 1'
                                    ? 'Diversified high-yield investment with flexible semi-annual or lump sum payouts'
                                    : plan.name === 'Plan 2'
                                        ? 'Progressive equity-backed UAE-based real estate investment with lump sum payouts'
                                        : 'Fixed equity-backed UAE-based real estate investment with lump sum payouts'
                            } size={'14.31px'} weight={250} color={'#FFF'} lineheight={'21.885px'} />
                            <Typography className='lg:hidden md:block hidden' opacity={0.6} text={
                                plan.name === 'Plan 1'
                                    ? 'Diversified high-yield investment with flexible semi-annual or lump sum payouts'
                                    : plan.name === 'Plan 2'
                                        ? 'Progressive equity-backed UAE-based real estate investment with lump sum payouts'
                                        : 'Fixed equity-backed UAE-based real estate investment with lump sum payouts'
                            } size={'11.4px'} weight={250} color={'#FFF'} lineheight={'21.885px'} />
                            <Typography className='lg:hidden md:hidden block' opacity={0.6} text={
                                plan.name === 'Plan 1'
                                    ? 'Diversified high-yield investment with flexible semi-annual or lump sum payouts'
                                    : plan.name === 'Plan 2'
                                        ? 'Progressive equity-backed UAE-based real estate investment with lump sum payouts'
                                        : 'Fixed equity-backed UAE-based real estate investment with lump sum payouts'
                            } size={'16px'} weight={400} color={'#FFF'} lineheight={'22px'} />
                        </div>
                        <div className='mt-9 px-[24.62px]' >
                            <Typography className='md:block hidden' text={'Minimum Investment:$50,000'} size={'10.31px'} weight={400} color={'#FFF'} lineheight={'19.149px'} transform={'uppercase'} family={'Supply'} />
                            <Typography className='md:hidden block' text={'Minimum Investment:$50,000'} size={'12px'} weight={400} color={'#FFF'} lineheight={'19.149px'} transform={'uppercase'} family={'Supply'} />
                            <div onClick={() => handleSelectPlan(plan)} className='md:mt-6 mt-4 flex h-10 justify-center items-center px-[6.839px] py-[12.414px] border-[0.684px] border-[#FFF] bg-[#000]'>
                                <Typography text={(<><span className='text-[#F00]'>|</span></>)} size={'11.31px'} weight={500} color={'#606060'} lineheight={'19.149px'} transform={'uppercase'} family={'Supply'} /> <input placeholder='ENTER INVESTMENT AMOUNT' style={{ lineHeight: '19.149px', zIndex: 20, fontStyle: 'normal', fontSize: '11.31px', fontWeight: '500', fontFamily: 'Supply', width: '100%', height: '100%', border: 'none', outline: 'none', background: 'transparent' }} className={`bg-transparent ${investmentAmount&& selectedPlan?.name === plan.name ? 'text-[#FFF]' : 'text-[#606060]'} outline-none border-none`} value={investmentAmount}
                                    onChange={handleInvestmentAmountChange} />
                            </div>
                            <CustomButton bgColor={selectedPlan?.name === plan.name ? '#DF0F11' : '#FFFFFF'} textColor={selectedPlan?.name === plan.name ? '#FFF' : '#000'} className={`mt-4`} text={'SELECTED PLAN'} onClick={() => handleSelectPlan(plan)} />
                        </div>
                    </div>
                ))}
                {/* {plans.map((plan, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-lg border ${selectedPlan?.name === plan.name
                            ? 'border-red-700 bg-[#2A2A2A]'
                            : 'border-[#353535] bg-[#1B1B1B]'
                            } cursor-pointer`}
                        onClick={() => handleSelectPlan(plan)}
                    >
                        <Typography
                            text={`${plan.term} YEAR${plan.term > 1 ? 'S' : ''}`}
                            color="#FFF"
                            size="18px"
                            weight={500}
                            transform="uppercase"
                        />
                        <Typography
                            text={`${plan.annualROI}% ROI / ANNUALLY`}
                            color="#FFF"
                            size="24px"
                            weight={600}
                            transform="uppercase"
                            className="mt-2"
                        />
                        <Typography
                            text={
                                plan.name === 'Plan 1'
                                    ? 'Diversified high-yield flexible semi-annual or lump sum payouts'
                                    : plan.name === 'Plan 2'
                                        ? 'Progressive equity-backed UAE-based real estate investment with lump sum payouts'
                                        : 'Fixed equity-backed UAE-based real estate investment with lump sum payouts'
                            }
                            color="#9CA3AF"
                            size="12px"
                            weight={300}
                            lineheight="170%"
                            className="mt-4"
                        />
                        <Typography
                            text={`MINIMUM INVESTMENT: $${plan.minInvestment.toLocaleString()}`}
                            color="#FFF"
                            size="12px"
                            weight={400}
                            transform="uppercase"
                            className="mt-4"
                        />
                        <CustomInput
                            placeholder="ENTER INVESTMENT AMOUNT"
                            value={investmentAmount}
                            onChange={handleInvestmentAmountChange}
                            className="mt-4 bg-[#2A2A2A] text-white border-[#353535]"
                        />
                        <CustomButton
                            text="SELECT PLAN"
                            className={`mt-4 w-full ${selectedPlan?.name === plan.name ? 'bg-red-700 text-white' : 'bg-white text-black'
                                }`}
                            onClick={() => handleSelectPlan(plan)}
                        />
                    </div>
                ))} */}
            </div>
            {error && (
                <Typography
                    text={error}
                    color="#EF4444"
                    size="14px"
                    weight={400}
                    className="mt-4 text-center"
                />
            )}
            {/* <div className="flex justify-between items-center mt-6">
                <div className="flex items-center border border-[#353535] px-4 py-2 rounded">
                    <Typography
                        text={`MINIMUM INVESTMENT AMOUNT: $${investmentAmount || '50,000'}`}
                        color="#FFF"
                        size="14px"
                        weight={400}
                        transform="uppercase"
                    />
                </div>
            </div> */}
        </div>
    );
};

export default SelectInvestment;